module.exports = __webpack_public_path__ + "img/gift0.f8a40571.png";